import { render } from "./YTable.vue?vue&type=template&id=0775a5b8&scoped=true"
import script from "./YTable.vue?vue&type=script&lang=js"
export * from "./YTable.vue?vue&type=script&lang=js"

import "./YTable.vue?vue&type=style&index=0&id=0775a5b8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0775a5b8"]])

export default __exports__